module.exports = __webpack_public_path__ + "static/media/section-three.1f556a85.png";